export default "__VITE_ASSET__BGhDDyMJ__"